// extracted by mini-css-extract-plugin
module.exports = {"container":"VerticalIntegrationIcons_container__IzvcN","icon":"VerticalIntegrationIcons_icon__1fiAc"};